import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container } from '@/components/layout/Container'
import { AccountTile } from '@/components/account/AccountTile'
import { Button } from '@/components/ui/Button'
import { useAuth } from '@/hooks/useAuth'
import { useUIStore } from '@/stores/uiStore'

const tiles = [
  { title: 'ACCESS BRONZE', to: '/account/loyalty' },
  { title: 'ORDERS AND RETURNS', to: '/account/orders' },
  { title: 'CREDITS AND REFUNDS' },
  { title: 'DETAILS AND SECURITY', to: '/account/details' },
  { title: 'ADDRESS BOOK', to: '/account/addresses' },
  { title: 'COMMUNICATION PREFERENCES', to: '/account/preferences' },
  { title: 'REFER A FRIEND' },
]

export function AccountDashboard() {
  const navigate = useNavigate()
  const { user, isSignedIn, loading, refreshUser, signOut } = useAuth()
  const openAuthModal = useUIStore((s) => s.openAuthModal)

  useEffect(() => {
    refreshUser()
  }, [refreshUser])

  const handleSignOut = async () => {
    await signOut()
    navigate('/')
  }

  if (loading && !isSignedIn) {
    return (
      <div className="pt-28 pb-24">
        <Container className="max-w-5xl">
          <p className="text-carbon/60">Loading your account...</p>
        </Container>
      </div>
    )
  }

  return (
    <div className="pt-28 pb-24">
      <Container className="max-w-5xl">
        <div className="mb-10">
          <p className="mb-2 text-xs uppercase tracking-[0.2em] text-wd-orange">
            my account
          </p>
          <h1 className="font-display text-3xl normal-case text-carbon md:text-4xl">
            Welcome to your account, {user?.name || user?.email || 'guest'}
          </h1>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
          {tiles.map((tile) => (
            <AccountTile
              key={tile.title}
              title={tile.title}
              to={tile.to}
              onClick={!tile.to ? () => {} : undefined}
            />
          ))}
        </div>

        {isSignedIn ? (
          <Button
            variant="secondary"
            onClick={handleSignOut}
            className="mt-8"
          >
            Sign out
          </Button>
        ) : (
          <div className="mt-8 flex flex-col items-start gap-3">
            <p className="text-sm text-carbon/70">
              Sign in to view orders, save your wishlist, and manage your details.
            </p>
            <Button
              variant="primary"
              onClick={() => openAuthModal('/account/dashboard')}
            >
              Sign in
            </Button>
          </div>
        )}
      </Container>
    </div>
  )
}
